<template>
<template-section v-if="!compact" :config="config" :linkName="linkName" :sectionName="sectionName" @deSelectSection="$emit('deSelectSection')" @selectSection="$emit('selectSection')" @removeSection="$emit('removeSection')">
	<h2 class="section-title" v-if="config.drag">Marquee</h2>
	<div class="marquee" v-if="!config.drag">
		<img src="/dashboard/img/marquee-banner-slug.jpg">
	</div>
</template-section>

<div v-else>Marquees <i class="fas fa-grip-horizontal"></i></div>

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'marquee',
	props: ['compact', 'config', 'options'],
	data() {
		return {
			linkName: "/website/marquees",
			sectionName: "Marquees",
			localOptions: {
				custom: 0,
				link: "",
				image: {
					image_id: null,
					image_src: "@/assets/img/marquee-banner-slug.jpg"
				}
			},
		}
	},
	watch: {
		options: {
			handler: function(value) {
				this.localOptions = value
			},
			deep: true
		},
		'localOptions.custom'(value) {
			this.updateTemplateData({ path: 'pageSections[' + this.computedIndex + '].options.custom', value: value })
		},
		'localOptions.link'(value) {
			this.updateTemplateData({ path: 'pageSections[' + this.computedIndex + '].options.link', value: value })
		}
	},
	computed: {
        // ...mapState('website', [
        //     'getTemplateData',
        // ]),
        ...mapGetters('website_module', [
            'getTemplateData'
        ]),
		// computedIndex() {
		// 	if (this.compact) return
		// 	return this.config.index - 1
		// }
	},
    methods: {
        ...mapActions('website_module', [
            'updateTemplateData'
        ])
    }
}
</script>

<style lang="scss" scoped>
</style>
